var render, staticRenderFns
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=3866ae84&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3866ae84",
  null
  
)

export default component.exports